<template>
    <div class="form-group m-form__group row" >
        <label class="col-lg-3 col-form-label" v-if="fullWidth != 1">{{ controlLabel }}</label>
        <div :class="fullWidth ? 'col-md-12' : 'col-md-9'">

            <div v-for="(item, index) in array"  class="form-input-array-wrapper"
                 :class="{'has-danger': form.errors.has(property+'.'+index)}">
                <div class="input-group">
                    <input v-model="array[index]" @input="changed" ref="input" autofocus
                           type="text" class="form-control  m-input" :placeholder="placeholder + ' ' + (index+1)">

                    <span class="input-group-btn">
                        <button @click.prevent="removeItem(index)" class="btn btn-danger" type="button"><i class="fa fa-minus"></i></button>
                    </span>
                </div>
                <span class="form-control-feedback" v-show="form.errors.has(property+'.'+index)">
                    {{ form.errors.get(property+'.'+index) }}
                </span>
            </div>

            <div v-if="array.length == 0" >
                <div  class="form-input-array-wrapper"
                     :class="{'has-danger': form.errors.has(property+'.0')}">
                    <div class="input-group">
                        <input v-model="array[0]" @input="changed"
                               type="text" class="form-control  m-input" :placeholder="placeholder + ' 1'">

                        <span class="input-group-btn">
                        <button @click.prevent="removeItem(0)" class="btn btn-danger" type="button"><i class="fa fa-minus"></i></button>
                    </span>
                    </div>
                    <span class="form-control-feedback" v-show="form.errors.has(property+'.0')">
                    {{ form.errors.get(property+'.0') }}
                </span>
                </div>
            </div>

            <button v-if="array.length > 0" @click.prevent="array.push('')" class="btn btn-success"><i class="fa fa-plus"></i></button>
        </div>
    </div>
</template>
<style>
    .form-input-array-wrapper{
        margin-top:5px;
        margin-bottom:5px;
    }
</style>
<script>
export default {
    props: {
        placeholder: String,
        label: String,
        property: String,
        form: Object,
        value: {},
        fullWidth: Number,
    },
    data() {
        return {
            array: [] 
        };
    },
    watch: {
        value(value) {
            this.assign(value);
            if (value.length === 1) {
                this.$nextTick(() => {
                    this.$refs.input[0].focus();
                });
            }
        }
    },
    methods: {
        assign(obj)
        {
            this.array = (obj && Array.isArray(obj)) ? obj : [];
        },
        changed() {
            this.$emit('input',  this.array);
        },
        removeItem(index){
            this.array = this.array.splice(index,1);
        }
    },
    mounted() {
        this.assign(this.value);
    },
    computed: {
        controlLabel() {
            return this.label || this.property.split('.')[0].replace(/_id$/, '').split('_').map(x => x.charAt(0).toUpperCase() + x.slice(1)).join(' ');
        },
    }
};
</script>



// WEBPACK FOOTER //
// resources/js/metronic/form/ArrayInput.vue